import { msg } from '@lingui/core/macro';
import type { MessageDescriptor } from '@lingui/core';

export const categoryMessages: Record<string, MessageDescriptor> = {
	basicNeeds: msg`Water and Energy`,
	humanRights: msg`Human Rights`,
	education: msg`Education & Job Insertion`,
	emergency: msg`Emergencies`,
	feeding: msg`Hunger and Food Security`,
	environment: msg`Environment`,
	habitat: msg`Social Inclusion`,
	health: msg`Health`,
};

export const sdgMessages: Record<number, MessageDescriptor> = {
	1: msg`No Poverty`,
	2: msg`Zero Hunger`,
	3: msg`Good Health and Well-being`,
	4: msg`Quality Education`,
	5: msg`Gender Equality`,
	6: msg`Clean Water and Sanitation`,
	7: msg`Affordable and Clean Energy`,
	8: msg`Decent Work and Economic Growth`,
	9: msg`Industry, Innovation and Infrastructure`,
	10: msg`Reduced Inequalities`,
	11: msg`Sustainable Cities and Communities`,
	12: msg`Responsible Consumption and Production`,
	13: msg`Climate Action`,
	14: msg`Life Below Water`,
	15: msg`Life on Land`,
	16: msg`Peace, Justice and Strong Institutions`,
	17: msg`Partnerships for the Goals`,
};

export const documentTypeMessages: Record<string, MessageDescriptor> = {
	id: msg`ID`,
	passport: msg`Passport`,
	taxId: msg`Tax Identification`,
	nie: msg`NIE`,
	others: msg`Others`,
};

export const errorMessages = {
	required: msg`This field is required`,
	invalidExtref: msg`The code is invalid, it must follow this format: {format}`,
	email: msg`The email address is badly formatted.`,
	emailAlreadyExists: msg`This email is already in use.`,
	password: msg`Your password must be 6 characters or more.`,
	confirmationCode: msg`Please enter the confirmation code.`,
	documentType: msg`Invalid document type`,
	termsAndConditions: msg`You must accept the terms and conditions`,
	amount: msg`Please select or enter a valid amount.`,
	amountTooHigh: msg`The amount must be less than {max} €.`,
	signIn: msg`Error signing in`,
	emailsDoNotMatch: msg`Email addresses do not match.`,
	passwordsDoNotMatch: msg`Passwords do not match.`,
	imageFormat: msg`Please drop an image file`,
	camera: msg`Cannot access the camera. Please make sure you have granted permission.`,
	expiredCode: msg`The code has expired.`,
	codeMismatch: msg`The code is incorrect. Please try again.`,
	notAuthorized: msg`Incorrect credentials. Please try again.`,
	userDoesNotExist: msg`The user does not exist.`,
	userNotConfirmed: msg`User not confirmed. Please confirm your email address first.`,
	userAlreadyConfirmed: msg`The user has already been confirmed.`,
	documentNumberExists: msg`The document number is already in use.`,
	limitExceeded: msg`You have reached the attempt limit. Please try again later.`,
	invalidPassword: msg`The password is invalid, it must be at least 6 characters and cannot contain spaces.`,
	captchaFailed: msg`CAPTCHA verification failed. Please try again.`,
	applePayUnavailable: msg`We could not start Apple Pay. Please choose another payment method.`,
	// The server refused the payment token (expired, or issued for another charge). Says "try again"
	// because that is literally the fix: the checkout mints a fresh one for the next attempt.
	paymentSessionExpired: msg`Your payment session is no longer valid. Please try again.`,
	internal: msg`Sorry, there was a problem, our team has already been informed, please try again later.`,
} satisfies Record<string, MessageDescriptor>;

/**
 * `amountTooHigh` needs a value, and the message extractor crashes on an object spread written
 * inside an `i18n._()` call, so the descriptor is assembled here instead of at the call site.
 */
export const amountTooHighMessage = (max: string): MessageDescriptor => ({
	...errorMessages.amountTooHigh,
	values: { max },
});
